import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RightPanelType } from '../enums/right-panel-type.enum';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { RightPanelStateService } from './right-panel-state.service';
import { TicketTabType } from '../enums/ticket-tab-type.enum';
import { FieldsService } from './ticket/fields.service';
import { TranslateService } from '@ngx-translate/core';
import { RightPanelService } from './right-panel.service';

@Injectable({ providedIn: 'root' })
export class TicketRightPanelService {
    data: {
        isFocusNeeded?: boolean;
        isShowEditUserForm?: boolean;
        ticket: any;
        tabType?: TicketTabType;
        userId?: string;
    };
    externalAppId?: number;
    isRightPanelOpened = false;
    onToggleRightPanelSubject = new Subject<any>();
    onActivateTabSubject = new Subject<any>();
    openUserEditFormSubject = new Subject<void>();
    tabType?: TicketTabType;
    type: RightPanelType;

    constructor(
        private commonDataService: CommonDataService,
        private rightPanelStateService: RightPanelStateService,
        private fieldsService: FieldsService,
        private translateService: TranslateService,
        private rightPanelService: RightPanelService,
    ) {}

    close(isNoNeedToSaveState?) {
        this.onToggleRightPanelSubject.next(true);

        this.isRightPanelOpened = false;
        this.data = {
            ticket: null,
        };

        if (!isNoNeedToSaveState) {
            this.rightPanelStateService.savePanelState(false);
        }
    }

    isNeedToDiscardUnsavedChanges(): boolean {
        if (
            this.isRightPanelOpened &&
            this.tabType === TicketTabType.editFields &&
            this.fieldsService.hasUnsavedChanges()
        ) {
            return window.confirm(
                this.translateService.instant('You have unsaved changes. Are you sure you want to discard them?'),
            );
        } else {
            return true;
        }
    }

    open(data = null, openIfActive = false, isSaveState = true) {
        if (!this.isNeedToDiscardUnsavedChanges()) {
            return;
        }

        data ??= {
            ticket: null,
        };

        this.onToggleRightPanelSubject.next(true);

        this.rightPanelService.close();

        if (this.commonDataService.isOneTime) {
            this.close(!isSaveState);
            return;
        }

        if (openIfActive) {
            this.restorePanelState(data);
            return;
        } else {
            this.data = data;

            if (data.tabType) {
                this.tabType = data.tabType;
            }
            this.isRightPanelOpened = true;
        }

        if (isSaveState) {
            this.rightPanelStateService.savePanelState(true);
        }
    }

    private restorePanelState(data) {
        const isPanelOpened = this.rightPanelStateService.getPanelState();

        if (isPanelOpened) {
            this.open(data);
            this.rightPanelStateService.savePanelState(true);
        } else {
            this.close();
        }
    }
}
